import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from "@/api/client"; // adjust import path if needed

import imageOne from '../../resource/dana/pirikara/1.png';
import imageTwo from '../../resource/dana/dana-calendar/3.png';
import imageThree from '../../resource/dana/pirikara/2.png';
import imageFour from '../../resource/dana/pirikara/3.png';
import imageFive from '../../resource/dana/pirikara/photo.jpg';

import TitleChnage from '../../Hook/TitleChnage';

const Pirikara = () => {
    TitleChnage("Pirikara");
    const navigate = useNavigate();

    const [contactDetails, setContactDetails] = useState([]);
    const [loading, setLoading] = useState(true);

    // NEW: Wanted / Unwanted lists from the admin panel
    const [wantedItems, setWantedItems] = useState([]);
    const [unwantedItems, setUnwantedItems] = useState([]);

    // Function to render contact value with appropriate link
    const renderContactValue = (contact) => {
        const value = contact.value;
        const type = contact.type || 'phone';

        switch (type) {
            case 'email':
                return (
                    <a
                        href={`mailto:${value}`}
                        style={{ color: '#c49b36', textDecoration: 'none' }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        {value}
                    </a>
                );
            case 'web':
                return (
                    <a
                        href={value}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#c49b36', textDecoration: 'none' }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        {value.replace(/^https?:\/\//, '').replace(/\/$/, '')}
                    </a>
                );
            case 'phone':
            default:
                const phoneNumber = value.replace(/[^0-9+]/g, '');
                return (
                    <a
                        href={`tel:${phoneNumber}`}
                        style={{ color: '#c49b36', textDecoration: 'none' }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        {value}
                    </a>
                );
        }
    };

    useEffect(() => {
        const fetchContactDetails = async () => {
            try {
                const response = await apiClient.get('/contact-setting');
                const settings = response.data.settings || {};
                const danaContacts = settings.dana || [];
                setContactDetails(danaContacts);
            } catch (error) {
                console.error('Error fetching contact details:', error);
                setContactDetails([]);
            } finally {
                setLoading(false);
            }
        };
        fetchContactDetails();
    }, []);

    // NEW: fetch the Pirikara lists. Failure here is non-fatal — headings
    // still render, just with nothing underneath.
    useEffect(() => {
        const fetchPirikaraItems = async () => {
            try {
                const response = await apiClient.get('/pirikara-items');
                setWantedItems(Array.isArray(response.data?.wanted) ? response.data.wanted : []);
                setUnwantedItems(Array.isArray(response.data?.unwanted) ? response.data.unwanted : []);
            } catch (error) {
                console.error('Error fetching Pirikara items:', error);
                setWantedItems([]);
                setUnwantedItems([]);
            }
        };
        fetchPirikaraItems();
    }, []);

    const handleClick = (event) => {
        const pathMap = {
            prikaraRequest: '/prikaraRequest',
        };

        const path = event.currentTarget.id;
        const targetPath = pathMap[path];

        if (targetPath) {
            navigate(targetPath);
        }
    };

    // NEW: shared renderer for a list. `items` is an array of { name, note }.
    // If empty, we render nothing under the heading.
    const renderItemList = (items) => {
        if (!items || items.length === 0) return null;
        return (
            <ol className='text-left font-p'>
                {items.map((item, index) => (
                    <li
                        key={index}
                        style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}
                    >
                        {item.name}
                        {item.note ? (
                            <span style={{ color: '#666', fontSize: '0.9em' }}>
                                {' '}({item.note})
                            </span>
                        ) : null}
                    </li>
                ))}
            </ol>
        );
    };

    return (
        <div className="pirikara-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className='font-main dark-gold p-4'>Pirikara</h1>
            <h3 className='mt-4 font-second p-4'>Necessities for the Sangha at Bhaddeka Vihari Monastery</h3>

            <p className="h4 p-4 mt-6 ">The Unparalleled Field of Merit, Worthy of Respect and Offering.</p>
            <p className="h4 p-4 mt-4 ">Buddha’s Word</p>

            <p className="h4 p-4 mt-6 ">As mentioned, offering necessities to the Sangha is a noble cause, one that reaps great rewards from this field of merit. These offerings provide the Sangha with the physical and mental strength required to lead a comfortable life and dedicate themselves to their practice.</p>
            <p className="h4 p-4 mt-5 ">The Melbourne community is diligently caring for the Sangha at Bhaddeka Vihari Monastery, and the Sangha gratefully accepts Pirikara (necessities). However, there is currently an excess of some items that have been offered, which are filling the storerooms. Notably, the eight necessary items (Ata Pirikara) remain in storage, as some robes and other items are either the wrong size or unsuitable. As a result, unnecessary items are accumulating in the storeroom, making it challenging for the Sangha to manage them.</p>
            <p className="h4 p-4 mt-5 ">To address this, a proper communication channel has been established to inform donors about the monastery’s current necessities. Donors can refer to the list below to identify the items needed by the monastery. Additionally, donors are always welcome to inquire by phone about the monastery's specific needs.</p>
            <p className="h4 p-4 mt-5 ">Instead of offering item Dana, devotees are encouraged to make monetary Dana directly to the monastery’s account. These funds will be used for various monastery projects, maintenance, and Sangha support—such as health, travel, and other essential needs.onors can contact the monastery to verify current needs and receive guidance on the most beneficial contributions. </p>
            <p className="h4 p-4 mt-5 ">The Buddha praises those who offer thoughtfully, ensuring that the recipient is worthy of such offerings. Offering what is needed makes Dana most rewarding.</p>
            <p className="h4 p-4 mt-5 ">Your support is deeply appreciated and vital to the well-being and practice of the Sangha.</p>

            <img src={imageFive} alt="" className='mt-6' style={{ width: "100%" }} />
            <div className="poem-1 mt-6">
                <p className="h4">Viceyya dānaṁ sugata-p,pasatthaṁ</p>
                <p className="h4">ye dakkhiṇeyyā idha jīva,loke</p>
                <p className="h4 p-4">etesu dinnāni maha-p,phalāni</p>
                <p className="h4 p-4">bījāni vuttāni yathā sukhette ti.</p>

                <p className="mt-6 h4 text-bold p-4">"The Blessed One praises giving thoughtfully</p>
                <p className=" h4 text-bold p-4">to those worthy of offerings in this world of the living.</p>
                <p className=" h4 text-bold p-4">What’s given to these is very fruitful,</p>
                <p className=" h4 text-bold p-4">like seeds sown in a fertile field.”</p>
            </div>

            <div className="calander-box mt-6 p-4">
                <div className="cl-right">
                    <h1 className='font-second text-black p-4 text-center'>-Wanted-</h1>
                    <div className="poem-1 p-4 mt-5">
                        {renderItemList(wantedItems)}
                    </div>
                </div>
                <div className="cl-left">
                    <h1 className='font-second text-black p-4 text-center'>-Unwanted-</h1>
                    <div className="poem-1 p-4 mt-5">
                        {renderItemList(unwantedItems)}
                    </div>
                </div>
            </div>

            <div className="p-4 mt-6 text-center">
                <div className="mt-6 calander-box align-item-center">
                    <div className="c-details text-left">
                        <h2 className='intro-text'>Contact Details</h2>
                        <div className="mt-4">
                            {loading ? (
                                <p className="font-p" style={{ color: '#999' }}>Loading contact details...</p>
                            ) : contactDetails.length === 0 ? (
                                <p className="font-p" style={{ color: '#999' }}>No contact details available.</p>
                            ) : (
                                contactDetails.map((contact, index) => (
                                    <p key={index} className="font-p">
                                        {contact.label}: {renderContactValue(contact)}
                                        {contact.note && <span style={{ color: '#666', fontSize: '0.9rem' }}> ({contact.note})</span>}
                                    </p>
                                ))
                            )}
                        </div>
                    </div>
                    <div className="d-button">
                        <img src={imageFour} alt="Right Top Image" width={300} className="right-image curser-pointer" id='prikaraRequest' onClick={handleClick} />
                    </div>
                </div>
            </div>

            <div className="bottom-box mt-5">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
        </div>
    );
};

export default Pirikara;